import React from 'react';
import HeroSection from '../../components/HeroSection';
import NewsGrid from '../../components/NewsGrid';
import WhatWeDoSection from '../../components/WhatWeDoSection';
import ImpactSection from '../../components/ImpactSection';

const HomeDesktop = ({ showImpactSection }) => (
  <>
    <HeroSection />
    <NewsGrid />
    <WhatWeDoSection />
    {showImpactSection && <ImpactSection />}
  </>
);

export default HomeDesktop;
